import { getDrugs } from "core/services/api"
import React, { useState, useEffect } from "react"
import Button from "../Button"
import Modal from "react-bootstrap/Modal"
import Box from "@mui/material/Box"
import TreatmentPlanRow from "./components"
import "./TreatmentPlan.scss"
import Toast from "components/Toast"
import { cancelPrescription, savePrescription, sendPrescription, updatePrescription } from "core/services/api/patientDiagnosisService"
import Multiselect from "multiselect-react-dropdown"
import { DragDropContext, Draggable, Droppable } from "@atlaskit/pragmatic-drag-and-drop-react-beautiful-dnd-migration"

function TreatmentPlan({
  isEditable,
  prescriptionPlanItem,
  prescriptionItem,
  prescriptionPlans,
  freezePrescription,
  setPrescriptionPlans,
  outerIndex,
  checkDrugInteraction,
  isReadOnly,
  printConsultant,
  setPrintConsultant,
  recordId,
  setIsLoading,
  updateSelectedInputValues,
  setSelectedInputValue,
  selectedInputValue
}: any) {
  const prescriptionPlanObj = {
    type: "",
    medicineName: "",
    dose: "",
    when: "",
    frequency: "",
    duration: "",
    instructions: "",
    isChosen: false,
    selectedSideEffects: []
  }

  const [sideEffectsList, setSideEffectsList] = useState<any>({})
  const [selectedMedicines, setSelectedMedicines] = useState<any>([])
  const [totalMedicines, setTotalMedicines] = useState<any>([])
  const [open, setOpen] = useState<boolean>(false)
  const [saved, setSaved] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<any>("")
  const [error, setError] = useState<boolean>(false)
  const [view, setView] = useState<boolean>(false)
  const [orderTemplates, setOrderTemplates] = useState<any>([])
  //Custom Toast
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [updatedDragEvent, setUpdatedDragEvent] = useState<any>()



  useEffect(() => {
    getDrugs()
      .then((res: any) => {
        setTotalMedicines(res)
      })
      .catch((err: any) => {
        setTotalMedicines([])
        console.log(err?.message)
      })
  }, [])

  useEffect(() => {
    if (prescriptionPlanItem) {
      if (prescriptionPlanItem?.medicines?.length > 0) {
        const tempSelectedMeds: any = []
        prescriptionPlanItem?.medicines?.forEach((ele: any) => {
          tempSelectedMeds.push(ele?.medicineName)
        })
        setSelectedMedicines(tempSelectedMeds)
      }
    }
  }, [prescriptionPlanItem])

  useEffect(() => {
    if (selectedMedicines?.length > 0 && totalMedicines?.length > 0) {
      const tempSideEffectsList: any = {}
      selectedMedicines.forEach((ele: any) => {
        const value: any = totalMedicines?.find((each: any) => each?.genericName === ele)
        const options = value?.sideEffects?.length > 0 ?
          value?.sideEffects?.map((e: any) => {
            return e
          }) : []
        tempSideEffectsList[ele] = options
      })
      setSideEffectsList(tempSideEffectsList)
    }

  }, [selectedMedicines, totalMedicines])

  function onValueChange(source: any, value: any, index: any, data?: any) {
    const values: any = { ...prescriptionPlanItem }
    if (!values["medicines"][index]) {
      values["medicines"][index] = {}
    }
    values["medicines"][index][source] = value

    const t = [...prescriptionPlans]
    t[outerIndex] = values
    setPrescriptionPlans(t)
    updateSelectedInputValues(t)

    // if (source === "medicineName") {
    //   if (values?.medicines?.length > 1) {
    //     checkDrugInteraction(values)
    //   }
    // }
  }

  function onDelete(index: number) {
    if (prescriptionPlanItem?.medicines?.length > 1) {
      const values = { ...prescriptionPlanItem }
      const selectedMeds = [...selectedMedicines]
      values?.medicines?.splice(index, 1)

      const t = [...prescriptionPlans]
      t[outerIndex] = values
      setPrescriptionPlans(t)
      updateSelectedInputValues(t)

      selectedMeds.splice(index, 1)
      setSelectedMedicines(selectedMeds)

      // if (values?.medicines?.length > 1) {
      //   checkDrugInteraction(values)
      // }
    }
  }

  const onSaveOrUpdate = (e: any) => {
    // setIsLoading(true)
    e.preventDefault()
    e.stopPropagation()

    const t = prescriptionPlans[outerIndex]
    const convertedPrescriptionPlanItem = t?.medicines?.map((ele: any) => {
      const t1 = { ...ele }

      if (t1["isChosen"] === false) {
        t1["selectedSideEffects"] = []
      }

      delete t1["isChosen"]
      // const t2 = ele?.selectedSideEffects?.map((ele: any) => ele?.value)
      // t1["selectedSideEffects"] = t2
      return t1
    })
    t["medicines"] = convertedPrescriptionPlanItem
    t["isSaved"] = true
    delete t["addToPrint"]

    if (e?.target?.innerHTML === "Save") {
      const count = prescriptionPlans?.length
      savePrescription(recordId, t, count)
        .then((res: any) => {
          const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
            each["addToPrint"] = true
            return each
          });;

          const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
            each["addToPrint"] = true
            return each
          });;

          const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

          setPrintConsultant(formatedPrintFollowUp)

          updatePrescriptions(res)
          setMessage("Saved Successfully")
          setIsSuccess(true)
          setIsLoading(false)
        })
        .catch((err: any) => {
          console.log(err?.message)
          setError(true)
          setIsLoading(false)
        })
    } else {
      // prescriptionPlanItem?.readyToSent
      if (prescriptionPlanItem?.readyToSent) {
        toggleDisplayToast({
          text: "Prescription cannot be resent to Medica as it was already sent once. The updated prescription will only be available in the MOC Application", type: 'warning',
          onUpdate: true,
          handleUpdatePrescription: () => updatePrescription(recordId, t)
            .then((res: any) => {
              const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
                each["addToPrint"] = true
                return each
              });;

              const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
                each["addToPrint"] = true
                return each
              });;

              const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

              setPrintConsultant(formatedPrintFollowUp)

              updatePrescriptions(res)
              //setMessage("")
              toggleDisplayToast({ text: "Updated Successfully", type: "success" })
              //setIsSuccess(true)
              setIsLoading(false)
            })
            .catch((err: any) => {
              console.log(err?.message)
              setError(true)
              setIsLoading(false)
            })
        })
      }
      else {
        updatePrescription(recordId, t)
          .then((res: any) => {
            const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
              each["addToPrint"] = true
              return each
            });;

            const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
              each["addToPrint"] = true
              return each
            });;

            const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

            setPrintConsultant(formatedPrintFollowUp)

            updatePrescriptions(res)
            //setMessage("Updated Successfully")
            toggleDisplayToast({ text: "Updated Successfully", type: "success" })
            //setIsSuccess(true)
            setIsLoading(false)
          })
          .catch((err: any) => {
            console.log(err?.message)
            setError(true)
            setIsLoading(false)
          })
      }
    }
  }

  const onSend = (e: any) => {
    // setIsLoading(true)
    e.preventDefault()
    e.stopPropagation()

    const t = prescriptionPlans[outerIndex]
    const convertedPrescriptionPlanItem = t?.medicines?.map((ele: any) => {
      const t1 = { ...ele }
      delete t1["isChosen"]
      // const t2 = ele?.selectedSideEffects?.map((ele: any) => ele?.value)
      // t1["selectedSideEffects"] = t2
      return t1
    })
    t["medicines"] = convertedPrescriptionPlanItem
    t["readyToSent"] = true

    sendPrescription(recordId, t)
      .then((res: any) => {
        const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });;

        const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });;

        const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

        setPrintConsultant(formatedPrintFollowUp)

        updatePrescriptions(res)
        setMessage("Sent Successfully")
        setIsSuccess(true)
        setIsLoading(false)
      })
      .catch((err: any) => {
        console.log(err?.message)
        setError(true)
        setIsLoading(false)
      })
  }

  const onCancel = (e: any) => {
    // setIsLoading(true)
    e.preventDefault()
    e.stopPropagation()

    const t = { ...prescriptionPlanItem }
    const convertedPrescriptionPlanItem = t?.medicines?.map((ele: any) => {
      const t1 = { ...ele }
      delete t1["isChosen"]
      // const t2 = ele?.selectedSideEffects?.map((ele: any) => ele?.value)
      // t1["selectedSideEffects"] = t2
      return t1
    })
    t["medicines"] = convertedPrescriptionPlanItem
    t["isCancelled"] = true

    cancelPrescription(recordId, t)
      .then((res: any) => {
        const prescriptionFiltered: any = res?.prescriptionPad?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });;

        const testFiltered: any = res?.testsRequired?.filter((e: any) => e?.isSaved).map((each: any) => {
          each["addToPrint"] = true
          return each
        });;

        const formatedPrintFollowUp: any = { ...res, prescriptionPad: prescriptionFiltered, testsRequired: testFiltered }

        setPrintConsultant(formatedPrintFollowUp)

        updatePrescriptions(res)
        setMessage("Cancelled Successfully")
        setIsSuccess(true)
        setIsLoading(false)
      })
      .catch((err: any) => {
        console.log(err?.message)
        setError(true)
        setIsLoading(false)
      })
  }

  const updatePrescriptions = (data: any) => {
    const { prescriptionPad } = data
    const tempPrescriptions = prescriptionPad?.map((each: any) => {
      const list = each["medicines"]?.map((ele: any) => {
        const t: any = { ...ele }
        if (t?.selectedSideEffects?.length > 0) {
          t.isChosen = true
        } else {
          t.isChosen = false
        }
        return t
      })
      const temp = { ...each }
      temp["medicines"] = list
      return temp
    })

    setPrescriptionPlans(tempPrescriptions)
    updateSelectedInputValues(tempPrescriptions)
  }

  const handleDragEnd = () => {
    const e = updatedDragEvent
    if (!e.destination) return
    let tempData = Array.from(prescriptionPlanItem?.medicines)
    let [source_data] = tempData.splice(e.source.index, 1)
    tempData.splice(e.destination.index, 0, source_data)
    prescriptionPlanItem["medicines"] = tempData
    const updatedArray = prescriptionPlans.map((item: any) => {
      if (item.id === prescriptionPlanItem.id) {
        return prescriptionPlanItem
      } else {
        return item
      }
    })

    if (prescriptionPlanItem) {
      if (prescriptionPlanItem?.medicines?.length > 0) {
        const tempSelectedMeds: any = []
        prescriptionPlanItem?.medicines?.forEach((ele: any) => {
          tempSelectedMeds.push(ele?.medicineName)
        })
        setSelectedMedicines(tempSelectedMeds)
      }
    }
    setPrescriptionPlans(updatedArray)
    updateSelectedInputValues(updatedArray)
  };

  const dropdownCancerOrder = orderTemplates.map((vals: any) => {
    return {
      label: 'Cycle Number: ' + '' + vals?.cycleNo + ' ' + '' + 'Date: ' + '' + vals?.chemoOrderForDate,
      value: vals?.id
    }
  })

  const setSideEffectsToEmpty = (i: any, j: any) => {
    const updatedArray: any = prescriptionPlans.map((item: any, index: any) => {
      if (i === index) {
        const updatedMedicines = item.medicines.map((medicine: any, medIndex: any) => {
          if (j === medIndex) {
            return { ...medicine, selectedSideEffects: [], isChosen: false };
          } else {
            return medicine;
          }
        });
        return { ...item, medicines: updatedMedicines };
      } else {
        return item;
      }
    });

    setPrescriptionPlans(updatedArray)
  }

  return (
    <div className="prescription-plan target-classname mt-4">
      {
        saved ? (
          <Toast
            textMessage="Side Effects Details Saved Successfully"
            onCloseText={"Close"}
            onClose={() => setSaved(false)}
            type="success"
          ></Toast>
        ) : isSuccess ? (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => setIsSuccess(false)}
            type="success"
          ></Toast>
        ) : error ? (
          <Toast
            textMessage="Something went wrong, Please try again later."
            onCloseText={"Close"}
            onClose={() => setError(false)}
            type="error"
          ></Toast>
        ) : ""

      }
      <div className="treatment-plan-container">
        <div className="heading">
          <div className="heading-left">
            <span>Prescription Pad</span>
          </div>
          {prescriptionPlanItem?.isSaved && <div className="heading-right">
            <span>
              Add to print
            </span>
            <input
              type="checkbox"
              className="add-to-print-checkbox"
              checked={prescriptionPlanItem?.addToPrint}
              onChange={(e: any) => {
                const temp: any = [...prescriptionPlans]
                temp[outerIndex]["addToPrint"] = e?.target?.checked
                const tempPrintConsultant: any = { ...printConsultant }
                tempPrintConsultant.prescriptionPad = temp.filter((e: any) => e?.isSaved)
                setPrintConsultant(tempPrintConsultant)
                setPrescriptionPlans(temp)
                updateSelectedInputValues(temp)
              }}
              disabled={isReadOnly}
            />
          </div>}
        </div>
        <div className="custom-table">
          <DragDropContext
            onDragUpdate={(e: any) => setUpdatedDragEvent(e)}
            onDragEnd={() => handleDragEnd()}>
            <table>
              <thead>
                <tr>
                  <th style={{ borderRadius: "8px 0 0 0" }}>#</th>
                  <th>Type</th>
                  <th>Medicine</th>
                  <th>Dose</th>
                  <th>When</th>
                  <th>Frequency</th>
                  <th>Duration</th>
                  <th>Notes/<br />Instructions</th>
                  <th>Side Effects</th>
                  <th style={{ borderRadius: "0px 10px 0 0" }} />
                </tr>
              </thead>
              <Droppable droppableId="id-0012" isDropDisabled={false}>
                {(provider: any) => (
                  <tbody ref={provider.innerRef}
                    {...provider.droppableProps}>
                    {prescriptionPlanItem?.medicines?.map((val: any, index: any) => (
                      <Draggable
                        key={`id_${index}`}
                        draggableId={`id_${index}`}
                        index={index}
                      >
                        {(provider: any) => (
                          <TreatmentPlanRow
                            provider={provider}
                            index={index}
                            eachPrescription={val}
                            isEditable={isEditable}
                            onValueChange={onValueChange}
                            onDelete={onDelete}
                            isReadOnly={isReadOnly}
                            freezePrescription={freezePrescription}
                            allDrugs={totalMedicines}
                            lengthMed={prescriptionPlanItem?.medicines?.length}
                            i={outerIndex}
                            selectedInputValue={selectedInputValue}
                            setSelectedInputValue={setSelectedInputValue}
                            setSideEffectsToEmpty={setSideEffectsToEmpty}
                          />
                        )}
                      </Draggable>
                    ))}
                    {provider.placeholder}
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>
          {(isEditable && !isReadOnly && !freezePrescription) && (
            <div className="comorbidities add-new">
              <div
                style={{ marginTop: "8px" }}
                className="add-new-button"
                onClick={() => {
                  const temp: any = [...prescriptionPlans]
                  temp[outerIndex]["medicines"].push(prescriptionPlanObj)
                  setPrescriptionPlans(temp)
                  updateSelectedInputValues(temp)
                }}
              >
                Add New
              </div>
            </div>
          )}
          {(isEditable && !isReadOnly) && (
            <div className="comorbidities add-new">
              <div
                className="show-side-effects-btn"
                onClick={() =>
                  setOpen(!open)
                }
              >
                Show Side Effects
              </div>
            </div>
          )}
          {
            open && prescriptionPlanItem?.id === prescriptionPlans[outerIndex]?.id && (
              Object.keys(sideEffectsList)?.length > 0 &&
              (
                <div className="custom-table side-effect-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Medicine</th>
                        <th style={{ borderRadius: "0 10px 10px 0" }}>Side Effects</th>
                        <td />
                      </tr>
                    </thead>
                    <tbody>
                      {
                        prescriptionPlanItem["medicines"]?.map((sideEffect: any, index: any) => {
                          return (prescriptionPlanItem && prescriptionPlanItem["medicines"][index] &&
                            prescriptionPlanItem["medicines"][index]["isChosen"] && (
                              <tr className="side-effect-row">
                                <td style={{ verticalAlign: "initial", padding: "20px" }}>{prescriptionPlanItem["medicines"][index]["medicineName"]}</td>
                                <td >
                                  {/* <Select
                                          options={sideEffectsList[sideEffect]}
                                          defaultInputValue={prescriptionPlanItem["medicines"][index]["selectedSideEffects"]}
                                          value={prescriptionPlanItem["medicines"][index]["selectedSideEffects"]}
                                          onChange={(option: any) => {
                                            onValueChange("selectedSideEffects", option, index)
                                          }}
                                          isDisabled={!isEditable || isReadOnly || freezePrescription}
                                          isMulti
                                        /> */}
                                  <Multiselect
                                    isObject={false}
                                    options={sideEffectsList[prescriptionPlanItem["medicines"][index]["medicineName"]]}
                                    selectedValues={
                                      prescriptionPlanItem["medicines"][index]["selectedSideEffects"]
                                    }
                                    onSelect={(data: any) => {
                                      onValueChange("selectedSideEffects", data, index)
                                    }}
                                    onRemove={(data: any) => {
                                      onValueChange("selectedSideEffects", data, index)
                                    }}
                                    disable={!isEditable || isReadOnly || freezePrescription}
                                  ></Multiselect>
                                </td>
                              </tr>
                            )
                          )
                        })
                      }
                    </tbody>
                  </table>
                  {(isEditable && !isReadOnly) && (
                    <div className="save-button mt-4" style={{ display: "flex", justifyContent: "flex-end", marginRight: "30px" }}>
                      {
                        isReadOnly ? ""
                          :
                          <Button
                            onClick={() => {
                              setSaved(true)
                            }}
                            text="Save"
                            id="save"
                          ></Button>
                      }
                    </div>
                  )}
                </div>
              )
            )
          }
        </div>
        {/* {isEditable && (
          <div className="save-button mt-4">
            <Button text="Save"></Button>
          </div>
        )} */}
        {
          view && (
            <Modal size="xl" show={view} onHide={() => setView(false)}>
              <Modal.Header closeButton>
                Cancelled Prescriptions
              </Modal.Header>
              <Modal.Body>
                <Box sx={{ width: "100%", marginTop: "20px" }}>
                </Box>
              </Modal.Body>
            </Modal >
          )
        }
      </div>
      {(isEditable && !isReadOnly) && (
        <div className="prescription-actions">
          <div className="save-button mt-4">
            {
              isReadOnly ?
                ""
                :
                <Button
                  text={!prescriptionPlanItem?.isSaved ? "Save" : prescriptionPlanItem?.id && prescriptionPlanItem?.prescriptionId ? "Update" : "Save"}
                  id="save"
                  onClick={(e: any) => {
                    onSaveOrUpdate(e)
                  }}
                  disabled={prescriptionPlanItem?.isCancelled ? true : false}
                ></Button>
            }
          </div>
          <div className="save-button mt-4">
            {
              isReadOnly ?
                ""
                :
                <Button
                  text="Send"
                  id="send"
                  onClick={(e: any) => {
                    onSend(e)
                  }}
                  disabled={prescriptionPlanItem?.isCancelled || prescriptionPlanItem?.readyToSent ? true : false || !prescriptionPlanItem?.id}
                ></Button>
            }
          </div>
          <div className="save-button mt-4">
            {
              isReadOnly ?
                ""
                :
                <Button
                  text="Cancel"
                  id="cancel"
                  onClick={(e: any) => {
                    onCancel(e)
                  }}
                  disabled={!prescriptionPlanItem?.readyToSent || prescriptionPlanItem?.isCancelled ? true : false}
                ></Button>
            }
          </div>
          {displayToast && (
            <Toast
              textMessage={displayToast?.text}
              type={displayToast?.type}
              onClose={() => {
                if (displayToast?.onUpdate) {
                  displayToast?.handleUpdatePrescription();
                }
                else {
                  toggleDisplayToast(false)
                }
              }}
              onCloseText="Close"
              onClickText={null}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default TreatmentPlan